import React, { useState, useEffect, useMemo } from "react";
import CardSummaryWaitingQueueUX from "./CardSummaryWaitingQueueUX";
import moment from "moment";
import { parseDate, formatADtoBEString } from "react-lib/utils/dateUtils";
import { DATE_FORMAT } from "react-lib/apps/Scheduling/common/Utils";
import { Icon, Button, Dropdown } from "semantic-ui-react";
import { CSVLink } from "react-csv";
import { useIntl } from "react-intl";

const staterDate = new Date().setMonth(new Date().getMonth() - 1);
const startDateDefault = moment(staterDate)?.format(DATE_FORMAT);
const endDateDefault = moment(new Date())?.format(DATE_FORMAT);

const startExportDateDefault = formatADtoBEString(moment(startDateDefault).format(DATE_FORMAT));
const endExportDateDefault = formatADtoBEString(moment(endDateDefault).format(DATE_FORMAT));

const CardSummaryWaitingQueue = (props: any) => {
  const intl = useIntl();
  const [selectDivisionPA, setSelectDivisionPA] = useState<any>(null);
  const [startDate, setStartDate] = useState(startDateDefault);
  const [endDate, setEndDate] = useState(endDateDefault);
  const [startExportDate, setStartExportDate] = useState(startExportDateDefault);
  const [endExportDate, setEndExportDate] = useState(endExportDateDefault);

  useEffect(() => {
    const allDivisionIds = (props.divisionOptions ?? []).map((option) => option.value as number);

    props.onEvent({
      message: "GetSummaryWaitingQueue",
      params: { data: { divisionId: allDivisionIds, endDate, startDate } },
    });
  }, [props.divisionOptions]);

  const dataSummaryQueue = useMemo(() => {
    return (props.summaryWaitingQueueList || []).map((item: any, index: number) => ({
      ...item,
      avg_paid_timg: "-",
      date: `${startExportDate} ถึง ${endExportDate}`,
    }));
  }, [props.summaryWaitingQueueList]);

  const changeDate = (key: string) => (value: any) => {
    console.log(value);
    const newDateString = (parseDate(value, true) as moment.Moment).format(DATE_FORMAT);
    if (key === "startDate") {
      setStartDate(newDateString);
      setStartExportDate(value);
    } else if (key === "endDate") {
      setEndDate(newDateString);
      setEndExportDate(value);
    }
  };

  //Export .CSV
  const headers = [
    { label: "วันที่รักษา", key: "date" },
    { label: "คลินิก", key: "division__name" },
    { label: "ระยะเวลาเฉลี่ยลงทะเบียน ถึง เข้าห้องพบแพทย์ (นาที)", key: "avg_check_in" },
    { label: "ระยะเวลาเฉลี่ยเข้าห้องแพทย์ ถึง ออกจากห้องแพทย์ (นาที)", key: "avg_check_out" },
    { label: "ระยะเวลาเฉลี่ยออกห้องแพทย์ - ชำระเงินเสร็จสิ้น (นาที)", key: "avg_paid_timg" },
  ];

  return (
    <>
      <CardSummaryWaitingQueueUX
        startDate={formatADtoBEString(moment(startDate).format(DATE_FORMAT))}
        endDate={formatADtoBEString(moment(endDate).format(DATE_FORMAT))}
        dataSummaryQueue={dataSummaryQueue}
        changeDate={changeDate}
        divisionSearch={
          <Dropdown
            value={selectDivisionPA}
            clearable
            fluid
            search
            selection
            options={props.divisionOptions}
            onChange={(e, data) => {
              setSelectDivisionPA(data.value);
            }}
          />
        }
        OnSearch={() => {
          const allDivisionIds = (props.divisionOptions ?? []).map((option) => option.value as number);

          props.onEvent({
            message: "GetSummaryWaitingQueue",
            params: {
              action: "search",
              data: {
                divisionId: selectDivisionPA || allDivisionIds,
                endDate,
                startDate,
              },
            },
          });
        }}
        buttonExportCSV={
          <CSVLink
            data={dataSummaryQueue}
            headers={headers}
            filename={intl.formatMessage({ id: "รายงานระยะเวลารอคิว.csv" })}
            target="_blank"
          >
            <Button color="orange">
              <div style={{ display: "flex" }}>
                <Icon name="download" />
                <div style={{ marginRight: "3px" }}> Export .CSV </div>
              </div>
            </Button>
          </CSVLink>
        }
        languageUX={props.languageUX}
      />
    </>
  );
};

export default CardSummaryWaitingQueue;
